import primaryComponents from "../../../primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useEffect } from "react";

export const StoreTerminalSelect = ({
  terminalList = [],
  terminal_type,
  assignedTerminal = {},
  setAssignedTerminal = () => {},
}) => {
  const handledAssignTerminal = (id) => {
    setAssignedTerminal((prev) => ({ ...prev, [terminal_type]: id }));
  };

  useEffect(() => {
    if (terminalList?.length === 1)
      handledAssignTerminal(terminalList?.[0]?.id);
  }, []);

  return (
    <>
      {terminalList?.length > 1 ? (
        <div
          className={`${globalStyles.cardWithBackground} py-2 card-plain mt-3`}
        >
          <primaryComponents.SelectField
            label={"Select POS Terminal"}
            options={terminalList}
            value={
              terminalList?.find(
                (terminal) =>
                  `${terminal?.id}` === `${assignedTerminal?.[terminal_type]}`,
              )?.terminal_sn || "Select terminal"
            }
            idKey={"id"}
            nameKey={"terminal_sn"}
            floatError={false}
            onChange={(value) => {
              handledAssignTerminal(value);
            }}
          />
        </div>
      ) : null}
    </>
  );
};
